export default __webpack_public_path__ + "static/media/brand-23.bc87509d.png";